import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import {
  faFileInvoiceDollar,
  faMoneyBillTransfer,
  faReceipt,
  faArrowLeft,
  faSearch,
  faArrowRightFromBracket
} from '@fortawesome/pro-light-svg-icons';
import {
  faArrowDown,
  faArrowUp,
  faChevronDown,
  faChevronLeft,
  faFileArrowDown,
  faPrint,

} from '@fortawesome/pro-regular-svg-icons';
import { SalesReportService } from 'src/app/services/sales-report.service';
import { saveAs } from 'file-saver';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CashRegisterService } from 'src/app/services/cash-register.service';
import { CartService } from 'src/app/services/cart.service';
import { DialogConfig, DialogGenericComponent } from '../dialog-generic/dialog-generic.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-cash-register-report-detail',
  templateUrl: './cash-register-report-detail.component.html',
  styleUrls: ['./cash-register-report-detail.component.scss'],
})
export class CashRegisterReportDetailComponent {
  // @ViewChild('containerScroll', { static: false }) containerScroll!: ElementRef;

  currentPage = 1;
  itemsPerPage = 12;
  loadingPage = false;
  finishScroll = false;
  // timeout = false;

  sessionId: any;
  session: any;
  displayedSessions: any[] = [];
  loaded = false;
  isRefound = false;
  faSearch = faSearch;
  faChevronLeft = faChevronLeft;
  faArrowRightFromBracket = faArrowRightFromBracket;
  faChevronDown = faChevronDown;
  faFileArrowDown = faFileArrowDown;
  faReceipt = faReceipt;
  faMoneyBillTransfer = faMoneyBillTransfer;
  faFileInvoiceDollar = faFileInvoiceDollar;
  faPrint = faPrint;
  faArrowLeft = faArrowLeft;
  faArrowUp = faArrowUp;
  faArrowDown = faArrowDown;


  selectedTab: any = 0;
  selectedStatus: any;
  searchText!: any;

  sortOrder: 'default' | 'asc' | 'desc' = 'default';
  id_business: any;
  channel: string = 'all';
  type: string = 'all';

  constructor(
    private activatedRoute: ActivatedRoute,
    private salesReportService: SalesReportService,
    private cashRegisterService: CashRegisterService,
    private cartService: CartService,
    private location: Location,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.activatedRoute.params.subscribe((data) => {
      this.sessionId = data['idSession'];
      if (this.sessionId) {
        this.getData();
      }
    });
    this.id_business = localStorage.getItem('id_business');
  }

  viewTicket(channel: any, id: any) {
    this.salesReportService.getPrintUrlTicketByTransaction(id).subscribe((res: any) => {


      window.open(res.data.ticket, '_blank');
    });
  }

  viewPrintTicket(channel: any, id: any) {
    this.salesReportService
      .getPrintUrlTicket(id)
      .subscribe((res: any) => {

        window.open(res.data.ticket_a4, '_blank');
      });
  }

  getJsonSeats(seats: string) {
    return JSON.parse(seats)?.id_bookings;
  }

  calculateTotal(n1: number, n2: number) {
    return Number(n1) + Number(n2);
  }
  goBack() {
    this.location.back();
  }

  goToCashRegisterReport() {
    this.router.navigateByUrl('/cash-register-report');
  }

  copyText(text: string, $event) {
    var tooltips = document.getElementsByClassName('myTooltip');
    navigator.clipboard.writeText(text);
    for (var i = 0; i < tooltips.length; i++) {
      tooltips[i].innerHTML = 'Texto copiado';
    }
  }

  outFunc() {
    var tooltips = document.getElementsByClassName('myTooltip');
    for (var i = 0; i < tooltips.length; i++) {
      tooltips[i].innerHTML = 'Copiar texto';
    }
  }

  downloadReport(id, codinv) {
    this.salesReportService.downloadReportSales(id).subscribe((data) => {
      var fileName = codinv + '.pdf';
      saveAs(data, fileName);
    });
  }

  formatNumber(floatValue = 1, decimals = 2, multiplier = 1) {
    let floatMultiplied = floatValue * multiplier;
    let stringFloat = floatMultiplied + '';
    let arraySplitFloat = stringFloat.split('.');
    let decimalsValue = '0';
    if (arraySplitFloat.length > 1) {
      decimalsValue = arraySplitFloat[1].slice(0, decimals);
    }
    let integerValue = arraySplitFloat[0];
    let arrayFullStringValue = [integerValue, decimalsValue];
    let FullStringValue = arrayFullStringValue.join('.');
    let floatFullValue = parseFloat(FullStringValue) + '';
    let formatFloatFullValue = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: decimals,
      style: 'currency',
      currency: 'EUR',
    }).format(Number(floatFullValue));
    return formatFloatFullValue;
  }

  tabChanged(event: MatTabChangeEvent) {
    this.selectedTab = event.index;
    this.selectedStatus = '';
    this.currentPage = 1;
    switch (event.index) {
      case 0:
        this.channel = 'all';
        break;
      case 1:
        this.channel = 'tpv';
        break;
      case 2:
        this.channel = 'cash';
        break;
      default:
        this.channel = 'all';
        break;
    }

    this.finishScroll = false;
    this.getData();
  }

  getData() {
    this.salesReportService.getSalesReportBySession(this.sessionId, this.currentPage, this.channel, this.type, this.sortOrder, this.searchText).subscribe((data: any) => {
      if (data) {
        this.loaded = true;
        if (data.last_page <= this.currentPage) {
          this.finishScroll = true;
        }
        if (this.currentPage == 1) {
          this.session = {cash_register: data.cash_register, initial_balance: data.initial_balance, totals: data.totals, work_time_closed: data.work_time_closed};
          this.displayedSessions = data.data.data;
        } else {
          this.displayedSessions = [...this.displayedSessions, ...data.data.data];
        }
        this.loadingPage = false;
      }
    });
  }

  filterTransactions(type: string) {
    this.selectedStatus = type;
    this.currentPage = 1;
    this.type = type;
    this.finishScroll = false;
    this.getData();
  }

  sortTransactions() {
    if (this.sortOrder == 'default') {
      this.sortOrder = 'asc';
    } else if (this.sortOrder == 'asc') {
      this.sortOrder = 'desc';
    } else if (this.sortOrder == 'desc') {
      this.sortOrder = 'default';
    }
    this.currentPage = 1;
    this.getData();
  }

  searchTransaction() {
    this.currentPage = 1;
    this.finishScroll = false;
    this.sortOrder = 'default';
    this.getData();
  }

  // Detecta el scroll infinito en la tabla
  @HostListener('window:scroll', [])
  onScroll() {
    if (this.loadingPage || this.finishScroll) return;


    const table = document.querySelector('.table');
    if (!table) return;

    const rect = table.getBoundingClientRect();
    const bottomShown = rect.bottom <= window.innerHeight;

    if (bottomShown) {
      this.currentPage++;
      this.loadingPage = true;
      setTimeout(() => {
        this.getData();
      }, 200);
    }
  }

  // Cargar más datos a la tabla
  getMoreTransactions() {


    const nextItems = this.session.data.data.slice(this.itemsPerPage, this.itemsPerPage + this.itemsPerPage);
    this.itemsPerPage += this.itemsPerPage;


    if (nextItems.length > 0) {
      this.displayedSessions = [...this.displayedSessions, ...nextItems];
      this.loadingPage = false;
    } else {
      this.finishScroll = true;
    }
  }

  goToDetail(id_transaction: any) {
    this.router.navigate(['/refunds/', id_transaction]);
  }

  closeWorkTime() {
    if (localStorage.getItem('id_cash_register')) {
      this.cashRegisterService.closeWorkTime(this.id_business, Number(localStorage.getItem('id_cash_register'))).subscribe(response => {
        if (response) {
          this.cartService.clearCartState();
          localStorage.removeItem('id_cash_register')
          localStorage.removeItem('cash_register_name')
          let idWorkingTime = localStorage.getItem('id_work_time')
          localStorage.removeItem('id_work_time')
          const config: DialogConfig = {
            title: 'Caja cerrada',
            subtitle: 'La caja ha sido cerrada correctamente',
            icon: 'circle-check',
            buttons: [
              {
                label: 'Aceptar', type: 'primary', action: () => {
                  this.router.navigate(['/select-cashregister']);
                  this.dialog.closeAll();

                }
              }
            ]
          };
          this.dialog.open(DialogGenericComponent, { data: config });
          this.dialog.afterAllClosed.subscribe(() => {
            this.router.navigate(['/select-cashregister']);
            this.dialog.closeAll();
          })

        }
      })
    }
  }
}
